/**
 * The learner's session for one membership, as kept in localStorage.
 *
 * The same `cm_<community_token>` key MembershipLogin writes on sign-in and
 * axiosSetup clears on a 401. Read through here rather than re-implementing the
 * parse, so the route guard and the pages agree on what "signed in" means.
 */
export const memberKey = (token) => `cm_${token}`;

export function readMember(token) {
  if (!token) return null;
  try {
    return JSON.parse(localStorage.getItem(memberKey(token)) || "null");
  } catch {
    // A corrupt entry is not a session. Returning null sends them to the login
    // page, which overwrites it — better than throwing on every render.
    return null;
  }
}

/** Whether a stored session is usable (has the token the API is called with). */
export const hasSession = (token) => !!readMember(token)?.member_token;
